import { apiAuth, apiResponseType } from ".";

export const getHolidaysData = (
  page: number = 1,
  name?: string
): apiResponseType =>
  apiAuth.get(
    `holidays?page=${page}${name ? `&name=${encodeURIComponent(name)}` : ""}`
  );

export const registerHolidaysData = (data) =>
  apiAuth.post("/holidays/store", data) as apiResponseType;

export const deleteHolidaysData = (uuid: string) =>
  apiAuth.delete(`holidays/${uuid}/destroy`) as apiResponseType;

export const updateHolidaysData = (uuid: string, data) =>
  apiAuth.post(`holidays/${uuid}/update`, data) as apiResponseType;

export const getShowHolidays = (uuid: string) =>
  apiAuth.get(`holidays/${uuid}/show`) as apiResponseType;

export const searchHolidaysData = (params: { name: string }): apiResponseType =>
  apiAuth.get(`holidays?name=${params.name}`);

export const setStatusHolidays = (uuid: string) =>
  apiAuth.put(`holidays/${uuid}/toggle-status`) as apiResponseType;

export const getSelectHolidays = () =>
  apiAuth.get(`holidays/select`) as apiResponseType;
